/**
 * Qué rutas son del sitio PÚBLICO y cuáles del CRM.
 *
 * Vivía adentro de `AnalyticsTracker` para decidir si un page_view era de un agente o de
 * un visitante. Salió a un módulo propio cuando apareció el segundo consumidor: Gustavo
 * renderiza su burbuja en los DOS layouts (un agente logueado que navega el sitio público
 * también lo ve), y las novedades internas no tienen nada que hacer ahí — son tutoriales
 * del CRM y el agente está mirando la web de cara al cliente.
 *
 * Una sola lista para las dos cosas: con dos copias, agregar una ruta pública nueva
 * arreglaba una y dejaba la otra mintiendo.
 */
export function esRutaPublica(p: string): boolean {
  return (
    p === '/' ||
    p === '/gustavo' ||
    p === '/catalogo' ||
    p.startsWith('/propiedades') ||
    p === '/nosotros' ||
    p === '/preguntas-frecuentes' ||
    p === '/sumate' ||
    p === '/contacto' ||
    p === '/tasar' ||
    p === '/precalificar' ||
    p.startsWith('/subastas') ||
    p.startsWith('/p/') ||
    p === '/login' ||
    p === '/novedades-tecnicas' ||
    p.startsWith('/portal')
  );
}
